import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import logoPng from '../images/logo.png'

interface Props {
	color: string
}

const Header: React.FC<Props> = ({ color }) => {
	const bgCSS: { backgroundColor: string } = {
		backgroundColor: color,
	}

	return (
		<div className="header" style={bgCSS}>
			<div>
				<div className="flex-center">
					<Link to="/">
						<img src={logoPng} alt="logo" />
					</Link>
				</div>
				<div>
					<nav>
						<NavLink
							to="/stories"
							className="header-link flex-center remove-tap-highlight"
							activeClassName="header-active">
							Stories
						</NavLink>
						<NavLink
							to="/playground"
							className="header-link flex-center remove-tap-highlight"
							activeClassName="header-active">
							Playground
						</NavLink>
					</nav>
				</div>
			</div>
		</div>
	)
}

export default Header
